/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindCertificatesKpiQueryResponse } from "../types/FindCertificatesKpi.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCertificatesKpiQueryKey = () =>
  [{ url: "/v1/certificate/find-certificates-kpi" }] as const

export type FindCertificatesKpiQueryKey = ReturnType<
  typeof findCertificatesKpiQueryKey
>

/**
 * @summary Find certificates kpi
 * {@link /v1/certificate/find-certificates-kpi}
 */
export async function findCertificatesKpi(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificatesKpiQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate/find-certificates-kpi`,
    ...requestConfig,
  })
  return res
}

export function findCertificatesKpiQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCertificatesKpiQueryKey()
  return queryOptions<
    ResponseConfig<FindCertificatesKpiQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificatesKpiQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findCertificatesKpi({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find certificates kpi
 * {@link /v1/certificate/find-certificates-kpi}
 */
export function useFindCertificatesKpi<
  TData = ResponseConfig<FindCertificatesKpiQueryResponse>,
  TQueryData = ResponseConfig<FindCertificatesKpiQueryResponse>,
  TQueryKey extends QueryKey = FindCertificatesKpiQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificatesKpiQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findCertificatesKpiQueryKey()

  const query = useQuery(
    {
      ...findCertificatesKpiQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
